export enum CompensationType {
  None = 'None',
  Sport = 'Sport',
  Medical = 'Medical',
  Robotics = 'Robotics',
  Wedding = 'Wedding',
  Children = 'Children',
  FamilyFuneral = 'FamilyFuneral',
  Recommendation = 'Recommendation',
  InternetCompensation = 'InternetCompensation',
  Other = 'Other',
}
